module.exports = __webpack_public_path__ + "img/UTFREM-19.0308b1d0.jpg";